import axios from "./axios";
import config from '../config/configJS';

// REST API pre správu SharePoint synchronizácie (/api/sharepoint/*). Admin-only na BE.
const BASE = config.endPoint + '/api/sharepoint';
const JSON_OPTS = {
  headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
  withCredentials: true,
};
const GET_OPTS = { withCredentials: true };

// ── Nastavenia + sync now ──
export function getSettings() {
  return axios.get(`${BASE}/settings`, GET_OPTS).then(r => r.data);
}
export function updateSettings(data) {
  return axios.put(`${BASE}/settings`, JSON.stringify(data), JSON_OPTS).then(r => r.data);
}
export function syncNow() {
  return axios.post(`${BASE}/sync-now`, '{}', JSON_OPTS).then(r => r.data);
}
export function syncStop() {
  return axios.post(`${BASE}/sync-stop`, '{}', JSON_OPTS).then(r => r.data);
}
export function getSyncStatus() {
  return axios.get(`${BASE}/sync-status`, GET_OPTS).then(r => r.data);
}

// ── Connections ──
export function listConnections() {
  return axios.get(`${BASE}/connections`, GET_OPTS).then(r => r.data);
}
export function createConnection(data) {
  return axios.post(`${BASE}/connections`, JSON.stringify(data), JSON_OPTS).then(r => r.data);
}
export function updateConnection(id, data) {
  return axios.put(`${BASE}/connections/${id}`, JSON.stringify(data), JSON_OPTS).then(r => r.data);
}
export function deleteConnection(id) {
  return axios.delete(`${BASE}/connections/${id}`, GET_OPTS);
}
export function uploadCertificate(id, file) {
  const fd = new FormData();
  fd.append('file', file);
  // Content-Type nenastavovať — axios doplní multipart boundary sám.
  return axios.post(`${BASE}/connections/${id}/certificate`, fd, GET_OPTS).then(r => r.data);
}
export function generateCertificate(id, forceNew = false) {
  return axios.post(`${BASE}/connections/${id}/certificate/generate?force_new=${forceNew ? 'true' : 'false'}`, '{}', JSON_OPTS).then(r => r.data);
}
export function downloadCertificate(id) {
  return axios.get(`${BASE}/connections/${id}/certificate/download`, { ...GET_OPTS, responseType: 'blob' }).then(r => r.data);
}
export function testConnection(id) {
  return axios.post(`${BASE}/connections/${id}/test`, '{}', JSON_OPTS).then(r => r.data);
}
// Redirect URI pre delegované prihlásenie = náš callback na tej istej adrese backendu,
// akú FE aj tak používa (config.endPoint). Správne pre dev aj prod (za IIS proxy) bez
// akéhokoľvek configu navyše. Túto hodnotu treba zaregistrovať v Azure (Authentication → Web).
export const delegatedRedirectUri = `${BASE}/delegated/callback`;

export function startDelegatedLogin(id, redirectUri) {
  const body = redirectUri ? JSON.stringify({ redirectUri }) : '{}';
  return axios.post(`${BASE}/connections/${id}/delegated/start`, body, JSON_OPTS).then(r => r.data);
}
export function getDelegatedStatus(id) {
  return axios.get(`${BASE}/connections/${id}/delegated/status`, GET_OPTS).then(r => r.data);
}
export function logoutDelegated(id) {
  return axios.delete(`${BASE}/connections/${id}/delegated`, GET_OPTS);
}

// ── Folder mappings ──
export function listFolders(connId) {
  return axios.get(`${BASE}/connections/${connId}/folders`, GET_OPTS).then(r => r.data);
}
export function createFolder(connId, data) {
  return axios.post(`${BASE}/connections/${connId}/folders`, JSON.stringify(data), JSON_OPTS).then(r => r.data);
}
export function updateFolder(id, data) {
  return axios.put(`${BASE}/folders/${id}`, JSON.stringify(data), JSON_OPTS).then(r => r.data);
}
export function deleteFolder(id) {
  return axios.delete(`${BASE}/folders/${id}`, GET_OPTS);
}

// ── Live browse (strom) ──
export function browse(connId, path) {
  const q = path ? `?path=${encodeURIComponent(path)}` : '';
  return axios.get(`${BASE}/connections/${connId}/browse${q}`, GET_OPTS).then(r => r.data);
}

// Orientačná veľkosť priečinka vrátane podpriečinkov → { files, bytes, complete, running } (ako zdieľaný disk)
export function folderSize(connId, path) {
  const q = path ? `?path=${encodeURIComponent(path)}` : '';
  return axios.get(`${BASE}/connections/${connId}/size${q}`, GET_OPTS).then(r => r.data);
}
